"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CloseModal = function CloseModal(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-[64px] w-[calc(100vw-20px)] flex items-center bg-white"
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "close-24",
    size: 24,
    className: "block h-[64px] ml-auto cursor-pointer mt-[0px]",
    onClick: onClose
  }));
};
var _default = CloseModal;
exports.default = _default;